/*
 * @Author: Ryan
 * @Date: 2026-01-13
 * @Description: TikTok Explore More Section - 探索更多工具
 */
import Link from 'next/link';
import React from 'react';

import {
  aiRemovalURL,
  aiVideoEditURL,
  avatarVideoProURL,
  faceSwapperURL,
  imageEnhanceURL,
  imageGenerateURL,
  imageTranslationURL,
  productAvatarURL,
  videoGenerateURL,
  videoTranslateURL,
  voiceCloneURL,
} from '@/utils/routeConstants';

import styles from './index.module.scss';

// 工具列表
const EXPLORE_TOOLS = [
  { name: 'AI Video Generator', href: videoGenerateURL },
  { name: 'AI Image Generator', href: imageGenerateURL },
  { name: 'AI Video Editor', href: aiVideoEditURL },
  { name: 'Video Translation', href: videoTranslateURL },
  { name: 'Image Translation', href: imageTranslationURL },
  { name: 'AI Avatar Generator', href: avatarVideoProURL },
  { name: 'Product Avatar', href: productAvatarURL },
  { name: 'Face Swap', href: faceSwapperURL },
  { name: 'AI Removal', href: aiRemovalURL },
  { name: 'Voice Clone', href: voiceCloneURL },
  { name: 'Image Enhance', href: imageEnhanceURL },
];

export interface TikTokExploreMoreSectionProps {
  /** 标题 */
  title?: string;
}

const TikTokExploreMoreSection: React.FC<TikTokExploreMoreSectionProps> = ({
  title = 'Explore More',
}) => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* 标题 */}
        <h2 className={styles.title}>{title}</h2>

        {/* 工具标签 */}
        <div className={styles.tagsWrapper}>
          {EXPLORE_TOOLS.map((tool, index) => (
            <Link key={index} href={tool.href} className={styles.tag}>
              {tool.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TikTokExploreMoreSection;
